import React, { useEffect, useRef, useState } from "react"
import { Info } from "lucide-react"

export const ToolTip = ({
  size = 16,
  className = "",
  placement = "top",
  fetchTooltipContent,
  title = "",
}) => {
  const tooltipRef = useRef(null)
  const [message, setMessage] = useState("")
  const [showTooltip, setShowTooltip] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleClick = async () => {
    setShowTooltip(true)

    // Don't call API again if data already loaded
    if (message) return

    try {
      setLoading(true)

      const data = await fetchTooltipContent()

      // adjust according to your API response
      setMessage(data)
    } catch (error) {
      setMessage("Failed to load data")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!showTooltip) return undefined

    const handleOutsideClick = (event) => {
      if (!tooltipRef.current?.contains(event.target)) {
        setShowTooltip(false)
      }
    }

    document.addEventListener("mousedown", handleOutsideClick)

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [showTooltip])

  return (
    <span
      ref={tooltipRef}
      className={`tooltip-container ${className}`}
      title={title}
    >
      <Info
        size={size}
        color="grey"
        onClick={handleClick}
        style={{
          verticalAlign: "middle",
          cursor: "pointer",
          zIndex: 1000,
        }}
      />

      {showTooltip && (
        <span className={`tooltip-text tooltip-${placement} tooltip-visible`}>
          {loading ? "Loading..." : message}
        </span>
      )}
    </span>
  )
}
